var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDirectHealthcareLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 50,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#45AC8B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.02 19c3.62 0 6.8 2.24 6.8 7s-3.18 7-6.8 7H5.86V19h10.16zm-1.36 10.98c2.72 0 4.56-.58 4.56-3.98s-1.84-3.98-4.56-3.98h-5.2v7.96h5.2zM39.122 19h3.6v14h-3.6v-5.48h-11.4V33h-3.6V19h3.6v5.48h11.4V19z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.62 29.42c2.36 0 3.8-.44 4.66-1.64h3.4c-.78 3-3.7 4.42-8.06 4.42-4.48 0-7.96-1.76-7.96-6.08 0-4.34 3.38-6.1 8.16-6.1 4.48 0 8.06 1.54 8.06 6.9H56.16c.38 1.88 2.18 2.5 4.46 2.5zm.18-6.8c-2.34 0-3.98.46-4.52 2.12h8.94c-.58-1.66-2.26-2.12-4.42-2.12zm17.072-2.6c4.92 0 7.72 1.58 7.76 6.04V32h-3.44v-1.46a15.818 15.818 0 0 1-7.16 1.66c-3.3 0-5.36-1.06-5.36-3.72 0-3.06 3.36-4.02 7.1-4.02 2.02 0 3.88.32 5.42.84 0-2.24-2.88-2.42-4.48-2.42-1.54 0-3.42.14-5.84.86l-1.22-2.5c2.4-.78 4.76-1.22 7.22-1.22zm4.32 8.32v-.92c-1.2-.38-2.82-.72-5-.72-2.56 0-4.1.44-4.1 1.64 0 1.24 1.14 1.34 2.92 1.34 1.86 0 4.42-.58 6.18-1.34zM87.235 16h3.42v16h-3.42V16zm16.725 7.08h-5.58v3.4c0 2.28.44 2.86 2.52 2.86 1.08 0 1.68 0 3.06-.2v2.76c-1.14.2-2.44.3-4.02.3-3.04 0-5-1.14-5-3.74v-5.38h-3.1v-2.86h3.1v-2.44l3.44-.98v3.42h5.58v2.86zm11.68-3.06c3.14 0 6.08 1.12 6.12 5.46l-.04 6.52h-3.44v-5.22c0-2.5-.84-3.8-3.66-3.8-2.3 0-4.78 1.18-5.84 2.42V32h-3.42V16h3.42v6.28c1.68-1.32 4-2.26 6.86-2.26z",
    fill: "#45AC8B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectHealthcareLogo);
export default __webpack_public_path__ + "static/media/direct-healthcare-logo.d50a40b14fa0a7d9ebc2dd7593e2df9e.svg";
export { ForwardRef as ReactComponent };